import OrganizationRepository from "@common/domain/data/OrganizationRepository";
import Organization from "@common/domain/entities/Organization";
import User from "@common/domain/entities/User";

export default class APIOrganizationRepository implements OrganizationRepository{
    getOrganizations(user: User): Promise<Organization[]> {
        throw new Error("Method not implemented.");
    }

}